import { FC } from "react";
import telegramIcon from "./icons/telegram.png";
import maxIcon from "./icons/max.png";
import { IPopupProps, Popup } from "../Popup";
import popupStyles from "../Popup.module.scss";
import { ChannelLink } from "../../Links/ChannelLink/ChannelLink";
import { getChannelLink, openPlatformLink } from "../../../utils/platform-links";
import { getPlatformText } from "../../../utils/platform-text";
import { isMaxPlatform } from "../../../platform/platform";

export const JoinChannelPopup: FC<IPopupProps> = ({ onClose }) => {
    const channel = getChannelLink();

    const description = (
        <>
            <p>
                <span>Удачи в розыгрыше и не забудьте подписаться на </span>
                <ChannelLink caption={`наш ${getPlatformText("channelName")}`} />
                <span>, в котором будет проходить розыгрыш 🎁</span>
            </p>
            <p>
                Именно там мы называем победителей, а как Вы сможете забрать подарок, если даже не узнаете, что выиграли его? 🤔
            </p>
        </>
    );

    const footer = (
        <div className={popupStyles.actions}>
            <button
                type="button"
                className={popupStyles.subscribeButton}
                onClick={() => {
                    if (!channel) return;
                    openPlatformLink(channel);
                }}
            >
                Подписаться
            </button>
            <button type="button" className={popupStyles.closeButton} onClick={onClose}>
                Закрыть
            </button>
        </div>
    );

    return (
        <Popup
            title="Не забудьте подписаться"
            description={description}
            icon={isMaxPlatform() ? maxIcon : telegramIcon}
            onClose={onClose}
            footer={footer}
        />
    );
};
